import { FC, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { useRouter } from "next/router";
import cName from 'classnames';
import { IndexContext } from "@/stores";
import axios from "axios";
import { Popover, SideSheet, Tree } from '@douyinfe/semi-ui';


export interface INavBarProps { }

export type NavType = {
  id: number,
  parent: number,
  name: string,
  path: string,
  outlink: string,
  children: NavType[]
}

interface RenderLabelProps {
  className?: string;
  onExpand?: any;
  onClick?: any;
  data: any;
  expandIcon?: React.ReactNode;
}

export const NavBar: FC<INavBarProps> = ({ }) => {
  const router = useRouter()
  // const [navData, setNavData] = useState<NavType[]>([])
  const [isExpand, setIsExpand] = useState<boolean>(false)
  const { nav, setNav, setTime, setLang } = useContext(IndexContext);
  const [address, setAddress] = useState('')
  const [openTime, setOpenTime] = useState<any>({
    start_time: '',
    end_time: ''
  })
  const [countTime, setCountTime] = useState({
    one: 0,
    ten: 0,
    hundred: 0,
  })
  // const [down, setDown] = useState(false)

  const transDate = useCallback((date: number): number => {
    return String(date).length === 10 ?
      date * 1000 : date

  }, [])

  const navTo = useCallback((e: any, item: NavType): void => {
    e.stopPropagation && e.stopPropagation();

    if (router.asPath == item.path) {
      return
    }
    setIsExpand(false)
    if (item.outlink) {
      const a = document.createElement("a")
      a.href = item.outlink
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      console.log(a);

      document.body.removeChild(a)
      return
    }
    if (!item.children.length) {

      router.push(item.path as any, item.path as any, {
        shallow: true
        // query: item.parent ? { id: active as any } : {}
      })
      // const parent = nav.find(nav =>
      //   nav.id === item.parent
      // ) as NavType
      return
    }

    router.push(item.children[0].path as any, item.children[0].path as any, {
      shallow: true
      // query: item.parent ? { id: active as any } : {}
    })
    // !item.children.length &&
  }, [nav, isExpand, router])

  const transTree = useCallback((root: any) => {
    if (!root.length)
      return [];
    return root.map((item: any) => {
      const { id, menu_name, pathinfo, pid, childlist, ...arg } = item
      return {
        ...arg,
        id,
        name: menu_name,
        path: pathinfo,
        parent: pid,
        children: [...transTree(childlist)]
      }
    })

  }, [])

  const getMenu = useCallback(async () => {
    const { data } = await axios.get('/api/menu')
    // setNavData(transTree(data.data.menu_tree))
    const start_time = transDate(data.data.expo_info.start_time)
    const end_time = transDate(data.data.expo_info.end_time)
    const daysDifference = Math.floor((start_time - Date.now()) / (1000 * 60 * 60 * 24)) + 1;
    setAddress(data.data.expo_info.expo_addr)
    setOpenTime({
      start_time: new Date(start_time).getFullYear() + '年' + (new Date(start_time).getMonth() + 1) + '月' + new Date(start_time).getDate() + '日',
      end_time: (new Date(end_time).getMonth() + 1) + '月' + (new Date(end_time).getDate()) + '日'
    })
    setCountTime({
      one: Math.floor(daysDifference % 10),
      ten: Math.floor((daysDifference / 10) % 10),
      hundred: Math.floor((daysDifference / 100) % 10),
    })
    setTime({
      start_time: new Date(start_time).getFullYear() + '年' + (new Date(start_time).getMonth() + 1) + '月' + new Date(start_time).getDate() + '日',
      end_time: (new Date(end_time).getMonth() + 1) + '月' + (new Date(end_time).getDate()) + '日',
      address: data.data.expo_info.expo_addr
    } as any)
    setNav(transTree(data.data.menu_tree))
  }, [])

  const transSelectData = useCallback((tree: any) => {
    return tree?.map((item: any) => {
      const { id, name, children, path } = item;
      const transformedChildren = children?.length
        ? transSelectData(children)
        : [];
      return {
        value: id,
        label: name,
        key: id + '',
        path,
        children: transformedChildren.map((child: any) => {
          return {
            ...child,
          };
        }),
      };
    });
  }, [nav]);

  const renderLabel: React.FC<RenderLabelProps> = ({
    className,
    onExpand,
    onClick,
    data,
    expandIcon,
  }) => {
    const { label } = data;
    const isLeaf = !(data.children && data.children.length);
    return (
      <li
        className={className}
        role="treeitem"
        onClick={isLeaf ? onClick : onExpand}
      >
        {isLeaf ? null : expandIcon}
        <span>{label}</span>
      </li>
    );
  };

  //在导航去除同期活动，因为二级页是详情页，放富文本的
  const getNav = useMemo(() => {
    return nav?.map((item: any) => {
      if (item.path === '/schedule')
        return {
          ...item,
          children: []
        }
      return item
    })
  }, [nav])

  useEffect(() => {
    getMenu()
  }, [])

  // useEffect(() => {
  //   const act = ?.id as any
  //   setActive(act)
  // }, [router])

  return (
    <div className={styles.header}>
      <div className={styles.top}>
        <div className={styles.left}>
          <a href="/" style={{ display: 'none' }} className={cName([styles.logo, 'minShow'])}>
            <img src="/image/footer-logo.png?v=20250422" alt="logo" />
          </a>
          <h1>CBCE亚洲国际精酿<br style={{ display: 'none' }} className="minShow" />啤酒会议暨展览会</h1>
          <p className={cName(['middleHidden'])}>
            <span className={styles.time}>{openTime.start_time}-{openTime.end_time}</span>
            <span className={styles.site}>{address}</span>
          </p>
        </div>
        <div className={styles.right}>
          <div className={cName([styles.clock, 'minHidden'])}>
            <span>展会倒计时</span>
            <div>
              <hr style={{ color: '#333' }} />
              <span className={cName({ [styles.current]: true })}>{countTime.hundred}</span>
            </div>
            <div>
              <hr style={{ color: '#333' }} />
              <span>{countTime.ten}</span>
            </div>
            <div>
              <hr style={{ color: '#333' }} />
              <span>{countTime.one}</span>
            </div>
            <span>天</span>
          </div>
          <div className={cName([styles.lang, 'minHidden'])}>
            <span><i></i>语言：</span>
            <p><span onClick={() => setLang('cn')}>中文 </span> <i>|</i> <span onClick={() => setLang('en')}> EN</span></p>
          </div>
        </div>
        <div className={cName([styles.expand, 'middleShow'])} onClick={() => setIsExpand(!isExpand)}>
          <img src="/image/menu.png" alt="" />
        </div>
      </div>
      <div className={cName([styles.bottom])}>
        <a href="/" className={cName([styles.logo, 'minHidden'])}>
          <img src="/image/footer-logo.png?v=20250422" alt="logo" />
        </a>
        <div>
          <div style={{ display: 'none' }} className={cName([styles.clock, 'minFlexShow'])}>
            <span>展会倒计时</span>
            <div>
              <hr style={{ color: '#333' }} />
              <span className={cName({ [styles.current]: true })}>{countTime.hundred}</span>
            </div>
            <div>
              <hr style={{ color: '#333' }} />
              <span>{countTime.ten}</span>
            </div>
            <div>
              <hr style={{ color: '#333' }} />
              <span>{countTime.one}</span>
            </div>
            <span>天</span>
          </div>
          <div style={{ display: 'none' }} className={cName([styles.lang, 'minFlexShow'])}>
            <span><i></i>语言：</span>
            <p><span onClick={() => setLang('cn')}>中文 </span> <i>|</i> <span onClick={() => setLang('en')}> EN</span></p>
          </div>
          <div className={cName([styles.nav, 'middleHidden'])}>
            <div
              className={cName([styles.navBottom])} >
              <ul>
                {
                  !!getNav &&
                  getNav.map(item => (
                    <Popover
                      showArrow
                      style={{ display: item.children.length ? 'block' : 'none' }}
                      content={
                        <div className={cName([styles.childList])}>
                          <div>
                            <div className={styles.right}>
                              <ul>
                                {
                                  item.children.map((child: any) => (
                                    <li key={child.id as any} onClick={(e) => navTo(e, child)}>
                                      {child.name}
                                      <span>{'>'}</span>
                                    </li>
                                  ))
                                }
                              </ul>
                            </div>
                          </div>
                        </div>
                      }
                      position='bottom'
                      key={item.id}
                    >
                      <li
                        className={cName({ [styles.active]: (router.asPath ==  item.path ) || ( item.path !='/' && router.asPath.includes(item.path)) })}
                        onClick={(e) => navTo(e, item)}
                      // onMouseEnter={(e) => {
                      //   console.log(e, item.id);
                      //   setActive(item.id)
                      // }}
                      // onMouseLeave={() => setActive(0)}
                      >
                        <div className={styles.parentItem}>
                          {item.name}
                        </div>
                        {/* <div className={cName([styles.triangle, 'minHidden', {
                        [styles.hidden]: active !== item.id
                          || !item.children.length
                      }])}>
                        <div><div></div></div>
                      </div> */}
                      </li>
                    </Popover>
                  ))
                }
              </ul>
              <span>|</span>
              <i></i>
            </div>
          </div>
          <div className={cName([styles.btns, 'minHidden'])}>
            <a href="/exhibition/apply">
              <div className={cName([styles.register, 'btnStyle'])}>
                <span>我要参展</span>
                {/* @ts-ignore */}
                <svg t="1723196878237" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                  <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#ffffff">
                  </path>
                </svg>
              </div>
            </a>
            <a href="https://cbce2025.gration.cn/?member/register&code=sites" target="_blank">
              <div className={cName([styles.order, 'btnStyle'])}>
                <span>我要参观</span>
                {/* @ts-ignore */}
                <svg t="1723196878237" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                  <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#FCB814">
                  </path>
                </svg>
              </div>
            </a>
          </div>
        </div>
      </div>
      <SideSheet title="CBCE亚洲国际精酿啤酒会议暨展览会" width={'75%'} visible={isExpand} onCancel={() => setIsExpand(!isExpand)} placement="left">
        <Tree
          treeData={transSelectData(getNav)}
          renderFullLabel={renderLabel}
          onSelect={(selectedKey, selected, selectedNode) => {
            navTo({}, selectedNode as NavType)
          }}
        />
      </SideSheet>
      <style jsx global lang='scss'>
        {
          `
            .semi-sidesheet-title{
              width:80%;
            }
            .semi-sidesheet .semi-tree-option{
              padding:8px 12px !important;
            }
          `
        }
      </style>
      {/* <MyModal visible={visible} onOk={() => setVisible(false)}></MyModal> */}
    </div >
  );
};
